"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "lazyLoadForceCheck", {
  enumerable: true,
  get: function get() {
    return _reactLazyload.forceCheck;
  }
});
exports["default"] = exports.lazyLoadDefaultProp = exports.lazyLoadPropType = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLazyload = _interopRequireWildcard(require("react-lazyload"));

var _reactImage = _interopRequireDefault(require("react-image"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Lazy Loaded Image
 * react-lazyload renders any component once it's near the viewport (offset)
 * react-image is a helper for loading an image with a small placeholder to prevent page jumps
 * https://css-tricks.com/content-jumping-avoid/
 *
 * The `placholder` node should be around the same size as the `src` image. A low quality image
 * of the same dimensions works good for this, or a div of the same dimensions.
 */
// eslint-disable-next-line react/prefer-stateless-function
var LazyImage = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(LazyImage, _React$PureComponent);

  var _super = _createSuper(LazyImage);

  function LazyImage() {
    _classCallCheck(this, LazyImage);

    return _super.apply(this, arguments);
  }

  _createClass(LazyImage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          src = _this$props.src,
          alt = _this$props.alt,
          lazy = _this$props.lazy,
          placeholder = _this$props.placeholder,
          lazyLoadProps = _this$props.lazyLoadProps,
          imageProps = _this$props.imageProps; // Turn off decoding feature in react-image for SVGs to avoid this bug in
      // safari: https://bugs.webkit.org/show_bug.cgi?id=188347

      var isSvg = /.svg/.test(src);

      var image = /*#__PURE__*/_react["default"].createElement(_reactImage["default"], _extends({
        className: className,
        src: src,
        loader: placeholder,
        alt: alt,
        decode: !isSvg
      }, imageProps));

      if (!lazy) {
        return image;
      }

      return /*#__PURE__*/_react["default"].createElement(_reactLazyload["default"], _extends({}, lazyLoadProps, {
        placeholder: placeholder
      }), image);
    }
  }]);

  return LazyImage;
}(_react["default"].PureComponent); // See react-lazyload README for info on LazyLoad props: https://github.com/twobin/react-lazyload#props


var lazyLoadPropType = {
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  once: _propTypes["default"].bool,
  offset: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
  scroll: _propTypes["default"].bool,
  resize: _propTypes["default"].bool,
  overflow: _propTypes["default"].bool,
  placeholder: _propTypes["default"].node,
  unmountIfInvisible: _propTypes["default"].bool,
  debounce: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].bool]),
  throttle: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].bool])
};
exports.lazyLoadPropType = lazyLoadPropType;
var lazyLoadDefaultProp = {
  height: undefined,
  once: true,
  offset: 100,
  scroll: true,
  resize: false,
  overflow: false,
  placeholder: null,
  unmountIfInvisible: false,
  debounce: undefined,
  throttle: 50
};
exports.lazyLoadDefaultProp = lazyLoadDefaultProp;
LazyImage.propTypes = _objectSpread({
  className: _propTypes["default"].string,
  lazy: _propTypes["default"].bool,
  src: _propTypes["default"].string
}, lazyLoadPropType);
LazyImage.defaultProps = _objectSpread({
  className: '',
  lazy: true,
  src: ''
}, lazyLoadDefaultProp);
var _default = LazyImage;
exports["default"] = _default;